<script lang="ts" setup>
import EnergyLabelOverview from "./EnergyLabelOverview.vue";

const props = defineProps({
  sourceData: {
    type: Object as () =>  Record<string, number>,
    required: true,
  },
  partyType: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div class="vue-chart building-energy-labels">
      <EnergyLabelOverview :partyType="props.partyType" :data-set="props.sourceData"></EnergyLabelOverview>
  </div>
</template>
